export default "__VITE_PUBLIC_ASSET__01ccbeba__"